module.exports = __webpack_public_path__ + "static/media/4.45b3892a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/cats/4.jpg
// module id = 209
// module chunks = 0